<div class="drop-zone-wrapper">
  <div class="card dashboard-card" [id]="dashboardWidget?.dashboardWidgetId">
    <div *ngIf="showActions" class="portlet-header">
      <div class="row header-row">
        <div class="col-2 p-0 text-left drag-handle widget-icon-btn" >
          <i class="fas fa-arrows-alt fa-lg widget-icon" *ngIf="!hideDragAndDrop"></i>
        </div>

        <div class="col text-center title-column">
          <div class="card-title text-center h6">
            <div
              [pTooltip]="(!hideTitleEdit ? 'Widgets.ClickToEditWidget' : '') | i18next: {'widgetTitle': dashboardWidget?.widget.title}"
              tooltipPosition="bottom"
              class="edit-title dk-gray truncate-title"
              [hidden]="editingTitle && !hideTitleEdit"
              [id]="'widgetTitle' + dashboardWidget.dashboardWidgetId"
              (click)="toggleEdit()"
              (mouseover)="hoveringTitle = true"
              (mouseout)="hoveringTitle = false"
            >
              {{ dashboardWidget?.widget.title }}
              <i
                class="fa fa-edit fa-sm"
                [id]="'editIcon' + dashboardWidget.dashboardWidgetId"
                [ngClass]="hoveringTitle && !hideTitleEdit ? 'edit-icon' : 'invisible'"
              ></i>
            </div>
            <div [hidden]="!editingTitle || hideTitleEdit">
              <input
                type="text"
                #titleEdit
                [id]="'titleEdit' + dashboardWidget.dashboardWidgetId"
                [(ngModel)]="dashboardWidget.widget.title"
                (blur)="toggleEdit()"
                (focus)="editTitleFocus()"
                (keypress)="editTitleKeyPress($event)"
              />
            </div>
          </div>
        </div>

        <div class="col-2 p-0 text-right card-settings d-flex justify-content-end align-items-start">
          <button
            type="button"
            class="btn btn-transparent p-0 widget-icon-btn"
            [ngClass]="{ 'move-icon-right': hideCog }"
            [pTooltip]="isShowingDataTable ? ('Widgets.ViewGraph' | i18next) : ('Widgets.ViewData' | i18next)"
            tooltipPosition="bottom"
            (click)="updateShowData()"
          >
            <i *ngIf="!isShowingDataTable" class="fa fa-table fa-lg widget-icon"></i>
            <i *ngIf="isShowingDataTable" class="fa fa-chart-bar fa-lg widget-icon"></i>
          </button>

          <button
            *ngIf="showInfoBtn"
            type="button"
            class="btn btn-transparent p-0"
            [pTooltip]="infoTooltipText"
            tooltipEvent="focus"
            tooltipPosition="bottom"
          >
            <i class="fa fa-info fa-lg widget-icon"></i>
          </button>

          <button type="button" class="btn btn-transparent p-0 widget-icon-btn" (click)="showConfig()" *ngIf="!hideCog">
            <i class="fa fa-cog fa-lg widget-settings-icon"></i>
          </button>
        </div>
      </div>
      <div class="row header-row no-padding">
        <div class="col text-center title-column" *ngIf="dashboardWidget.widget | widgetSubtitle">
          <div class="card-title text-center h7">
            <div
              [pTooltip]="dashboardWidget.widget | widgetSubtitleTooltip"
              tooltipPosition="bottom"
              class="dk-gray truncate-title"
              [id]="'widgetSubTitle' + dashboardWidget.dashboardWidgetId"
            >
              {{ dashboardWidget.widget | widgetSubtitle }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!isShowingDataTable; else viewDataTemplate" class="card-body pb-2 portlet-content">
      <ng-content></ng-content>
    </div>

    <ng-template #viewDataTemplate>
      <div class="card-body card-table px-2">
        <hb-view-data-widget [dashboardWidget]="dashboardWidget" [widgetTableData]="widgetTableData"> </hb-view-data-widget>
      </div>
    </ng-template>

    <div *ngIf="showDataOption && hasItemizedDataView && isShowingDataTable" class="text-center d-inline-block w-100 pb-2">
      <a class="output-link" (click)="showOverall()">{{'Widgets.Overall' | i18next}}</a> | <a class="output-link" (click)="showItemized()">{{'Widgets.Itemized' | i18next}}</a>
      <span *ngIf="itemizedDataFilterName"> | {{ itemizedDataFilterName }}</span>
    </div>
  </div>
</div>
